import { ETokenStyleClass } from 'typedefs/ETokenStyleClass';

/** Describes a region in the code (sequence of tokens) that must be formatted in the same token style. */
export class StyleRegion {
	/** A default style class for regions without a specific style. */
	public static NO_STYLE: ETokenStyleClass = ETokenStyleClass.PLAIN_TEXT;

	/**
	 * Constructs a style region.
	 *
	 * @param startOffset Offset of the first token in the region
	 * @param endOffset Offset of the first token after the region
	 * @param styleCssClassName Css-class name for token style for this region
	 * @param tokenStyleClass The ETokenStyleClass for this region
	 */
	public constructor(
		public startOffset: number,
		public endOffset: number,
		public styleCssClassName: string,
		public tokenStyleClass: ETokenStyleClass
	) {}
}
